export default __webpack_public_path__ + "static/media/dashboard.cce75452.svg";